module.exports = __webpack_public_path__ + "media/images/application/placeholder/placeholder-14x9-0f00a1785266481245f7db7595310f45.jpg";